export const appText = {
    app_name: "Box",
    footer_text: "© Box.com 2020 - - - - Box is online supermarket and deliver grocery and household item in sahiwal.",
    titlePrefix: "Box.com.pk",
    defaultTitle: "Box.com.pk - The online supermarket, buy grocery online , food items & more'",

    about_app: "About Box",

}